import styled from "styled-components";


export const NarrowContent = styled.div`
  padding: 20px;
  max-width: 500px;
  margin: auto;
`;

export const WideContent = styled.div`
  padding: 10px 20px;
  max-width: 800px;
  margin: auto;
  background-color: white;
`;
